import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#000',
  width = '100%',
  className = '',
  viewBox = '0 0 20.699 20.699',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="Camada_2" data-name="Camada 2">
      <g id="Layer_2" data-name="Layer 2">
        <path
          fill={fill}
          d="M18.35,9.335A9.014,9.014,0,1,1,9.335,18.35,9.015,9.015,0,0,1,18.35,9.335M18.35,8A10.35,10.35,0,1,0,28.7,18.35,10.351,10.351,0,0,0,18.35,8Zm-1.5,14.356h.5V17.348h-.5a.5.5,0,0,1-.5-.5v-.334a.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5v5.843h.5a.5.5,0,0,1,.5.5v.334a.5.5,0,0,1-.5.5h-3a.5.5,0,0,1-.5-.5v-.334A.5.5,0,0,1,16.847,22.356Zm1.5-10.016a1.335,1.335,0,1,0,1.335,1.335A1.335,1.335,0,0,0,18.35,12.34Z"
          transform="translate(-8 -8)"
        />
      </g>
    </g>
  </svg>
);

export default SVG;
